<template>
  <div>
    <div class="header">
      <Header></Header>
    </div>
    <div class="more">
      <ul>
        <li v-for="item in tableData">
          <el-card :body-style="{ padding: '0px' }" style="width: 100%;height: 100%;cursor: pointer" shadow="hover">
            <div @click="toSignUp(item.confId)">
              <el-row style="height:150px;width: 100%;">
                <div>
                  <img :src="'https://member.nfsoc.org.cn:8666'+item.poster" alt="" width="270" height="150">
                </div>
              </el-row>
              <el-row style="height: 38px;padding:0 12px;border-top: 1px solid black">
              <span style="
              display: inline-block;
              width: 100%;
              line-height: 50px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              word-break: keep-all;
              font-size: 16px;
              height: 50px">
                {{item.confName}}
              </span>
              </el-row>
              <el-row style="padding:0 12px;">
                <i class="el-icon-timer" style="font-size: 12px;line-height: 15px"></i>
                <span style="width: 100%;overflow: hidden;text-overflow:ellipsis;font-size: 12px;line-height: 15px;height: 15px; white-space: nowrap;
              word-break: keep-all;">{{item.startTime}}</span>
              </el-row>
              <el-row style="padding:0 12px;">
                <i class="el-icon-location-outline" style="font-size: 12px;line-height: 15px"></i>
                <span style="width: 100%;overflow: hidden;text-overflow:ellipsis;font-size: 12px;line-height: 15px;height: 15px; white-space: nowrap;
              word-break: keep-all;">{{item.venueAddress}}</span>
              </el-row>
            </div>
          </el-card>
        </li>
      </ul>
      <div class="page">
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="foot" style="height: 50px;width: 100%;float: left"></div>
  </div>
</template>

<script>
export default {
  name: "more",
  data(){
    return {
      currentPage:1, //当前页数
      pageSize: 12 ,//每页条数
      total:1,

      tableData:[],
    }
  },
  methods:{
    //加载
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: 'Under heavy load',
        spinner: 'el-icon-loading',
        background: 'rgba(0.7)'
      });

    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.getAllList(val)
    },
    async getAllList(currentPage){
      this.openFullScreen()
      const { data: res } = await this.$http.get
      ('api/conference/confDetailed/user/list?pageNum='+currentPage+'&pageSize='+this.pageSize)
      // console.log(res);
      this.total = res.total
      this.tableData = res.rows
      this.loading.close();
    },
    async toSignUp(id){
      let routeData = this.$router.resolve({ path: '/signup',query:{id:id}
      });
      window.open(routeData.href, '_blank');
    },
  },
  created() {
    this.getAllList(1)
  }
}
</script>

<style scoped lang="less">
.more{
  width: 100%;
  height: 100%;
  float: left;
}
ul{
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 1400px;
  margin: 35px auto;
  padding: 0;
  float: left;
}
li{
  list-style: none;
  margin: 20px 20px 30px 50px;
  background-color: white;
  width: 270px;
  height: 240px;
  float: left;
}
.page{
  width: 100%;
  text-align: center;
  float: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
}
</style>
